import { Link } from 'react-router-dom'
import { useTheme } from '../hooks/useTheme'

// styles
import './Navbar.css'

export default function Navbar() {
    const { color } = useTheme()

    return (
        <div className='navbar' style={{ background: color }}>
            <nav>
                <Link to="/" className="brand">
                    <h1>Claire Filipek | CS Education Portfolio</h1>
                </Link>
                <Link to="/contact">
                    Contact Me
                </Link>
            </nav>
        </div>
    )
}